import React, { useEffect, useState } from 'react';
import liracrypt from '../Liracrypt/liracrypt';
import { Col, Form, Row, Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


const StaticDropdownTree = ({
    form,
    name,
    defaultValue,
    api,
    params
}) => {
    const [dropdownList, setDropdownList] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        liracrypt.get(api, params).
            then(response => {
                form.setFieldValue(response.data.data.data_index, defaultValue);
                let dropdownData = [response.data.data];
                if (defaultValue) {
                    defaultValue.forEach((x, i) => {
                        let nextData = dropdownData[i].data.find(y => y.value === x);
                        if (nextData.child) {
                            dropdownData.push(nextData.child);
                        }
                    });
                }
                setDropdownList(dropdownData);
                setLoading(false);
            }).catch(err => {
                console.log(err);
            })
    }, []);

    const onDropdownChange = ({ val, index }) => {
        let dList = [...dropdownList];
        let currentDropdown = dList[index].data
        let selectedValue = currentDropdown.find(x => x.value === val);
        if (selectedValue.child) {
            let nextIndex = index + 1;
            dList[nextIndex] = selectedValue.child;
            setDropdownList(dList);
        } else {
            let values = form.getFieldValue(name);
            if (values) {
                console.log(dList);
                values.splice(index + 1, dList.length);
                console.log(values);
                form.setFieldValue(name, values)
            };
            dList.splice((index + 1), dList.length);
            setDropdownList(dList);
        };
    }

    return (
        <Row>
            {
                loading ? <div style={{display: 'flex', width: '100%', justifyContent: 'center'}}>
                    <Spin indicator={<LoadingOutlined spin style={{fontSize: 70}} />} />
                </div> :
                    dropdownList.length &&
                    dropdownList.map((dropdown, index) => (
                        <Col className='static-dropdown-tree' span={dropdown.colSize} key={index}>
                            <Form.Item name={[name, index]} label={dropdown.label} rules={[
                                { required: dropdown.required, message: dropdown.errorMessage }
                            ]}>
                                <Select
                                    onChange={(value) => onDropdownChange({ val: value, index })}
                                    options={dropdown.data}
                                    placeholder={dropdown.placeHolder || "Please Select"}
                                    showSearch={dropdown.isSearchable}
                                    style={{}}
                                    showArrow={true}
                                />
                            </Form.Item>
                        </Col>
                    ))
            }
        </Row>
    )
};

export default StaticDropdownTree;